/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findTransferringVets } from '../fn/transferring-vets/find-transferring-vets';
import { FindTransferringVets$Params } from '../fn/transferring-vets/find-transferring-vets';
import { TransferringVets } from '../models/transferring-vets';

@Injectable({ providedIn: 'root' })
export class TransferringVetsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findTransferringVets()` */
  static readonly FindTransferringVetsPath = '/api/values/transferring-vets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findTransferringVets()` instead.
   *
   * This method doesn't expect any request body.
   */
  findTransferringVets$Response(params?: FindTransferringVets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransferringVets>>> {
    return findTransferringVets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findTransferringVets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findTransferringVets(params?: FindTransferringVets$Params, context?: HttpContext): Observable<Array<TransferringVets>> {
    return this.findTransferringVets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TransferringVets>>): Array<TransferringVets> => r.body)
    );
  }

}
